import { render, staticRenderFns } from "./mo_module.vue?vue&type=template&id=800722c6&scoped=true"
import script from "./mo_module.vue?vue&type=script&lang=js"
export * from "./mo_module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800722c6",
  null
  
)

export default component.exports